import React from "react";
import { StatusButton, StatusButtonProps } from "./StatusButton";
import { Box } from "../../platform-style";

// TODO: This component needs a complete rework once legacy support is no longer required

interface StatusButtonsProps {
  statusButtonProps: StatusButtonProps[];
}

export const StatusButtons = (props: StatusButtonsProps) => {
  return (
    <>
      {props.statusButtonProps.map((statusButton, index) => (
        <Box component={"span"} sx={{ mr: 1 }} key={"box" + statusButton.label + index}>
          <StatusButton
            status={statusButton.status}
            label={statusButton.label}
            startIcon={statusButton.startIcon}
            endIcon={statusButton.endIcon}
            size={statusButton.size}
            key={statusButton.label + index}
            onClick={statusButton.onClick}
            tooltip={statusButton.tooltip}
            disabled={statusButton.disabled}
          />
        </Box>
      ))}
    </>
  );
};
